var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
      staticClass: "box-list-recognition-dialog",
      attrs: {
        title: _vm.$t("SeaExport.BoxListRecognition"),
        visible: _vm.innerVisible,
        "close-on-press-escape": false,
        "close-on-click-modal": false,
        width: "678px"
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _c("div", { staticClass: "upload-area" }, [
        _vm.step === 1
          ? _c("div", { staticClass: "drop-area" }, [
              _c(
                "div",
                { staticClass: "drop-info" },
                [
                  _c(
                    "el-upload",
                    {
                      ref: "upload",
                      staticClass: "el-upload-body",
                      staticStyle: { "text-align": "center" },
                      attrs: {
                        action: _vm.URL.common.uploadStorage,
                        headers: _vm.headers,
                        data: _vm.uploadParams,
                        "auto-upload": false,
                        multiple: true,
                        "show-file-list": false,
                        "before-upload": _vm.beforeUpload,
                        "on-change": _vm.handleChange,
                        "on-success": _vm.uploadSuccess,
                        "on-error": _vm.uploadFaild,
                        drag: "",
                        accept:
                          ".pdf,.jpg,.jpeg,.png,.gif,.txt,.xls,.xlsx,.doc,.docx"
                      }
                    },
                    [
                      _c("img", {
                        staticClass: "drop-icon-large",
                        attrs: {
                          src: require("@/assets/icons/ai-recognition-folder.png"),
                          alt: ""
                        }
                      }),
                      _c("div", { staticClass: "el-upload__text" }, [
                        _vm._v(" " + _vm._s(_vm.$t("SeaExport.DragOrClick"))),
                        _c("em", [
                          _vm._v(_vm._s(_vm.$t("SeaExport.ClickUpload")))
                        ])
                      ]),
                      _c(
                        "div",
                        {
                          staticClass: "el-upload__tip",
                          attrs: { slot: "tip" },
                          slot: "tip"
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t("SeaExport.SupportingUploadFormat")
                              ) +
                              " "
                          )
                        ]
                      )
                    ]
                  )
                ],
                1
              )
            ])
          : _vm._e(),
        _vm.step === 2
          ? _c("div", { staticClass: "progress-area" }, [
              _c(
                "div",
                {
                  staticStyle: { "text-align": "center", "margin-top": "10px" }
                },
                [
                  _c("img", {
                    attrs: {
                      src: require("@/assets/icons/ai-recognition-pdf.png"),
                      alt: ""
                    }
                  }),
                  _c("p", [
                    _vm._v(_vm._s(_vm.$t("SeaExport.RecognitionInProgress")))
                  ]),
                  _c("el-progress", {
                    attrs: {
                      type: "line",
                      "show-text": false,
                      percentage: _vm.uploadProgress
                    }
                  })
                ],
                1
              )
            ])
          : _vm._e(),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.fileList.length > 0,
                expression: "fileList.length > 0"
              }
            ]
          },
          [
            _c("p", { staticStyle: { "font-size": "18px" } }, [
              _vm._v(_vm._s(_vm.$t("SeaExport.UploadedFile")))
            ]),
            _c(
              "el-table",
              {
                staticStyle: { border: "1px" },
                attrs: {
                  data: _vm.fileList,
                  "show-header": false,
                  height: "185px"
                }
              },
              [
                _c("el-table-column", {
                  attrs: { label: "", width: "450px" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(scope) {
                        return [_c("span", [_vm._v(_vm._s(scope.row.name))])]
                      }
                    }
                  ])
                }),
                _c("el-table-column", {
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _c(
                            "el-button",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.step === 1,
                                  expression: "step === 1"
                                }
                              ],
                              staticStyle: { color: "red" },
                              attrs: { type: "text" },
                              on: {
                                click: function($event) {
                                  return _vm.removeFile(scope.row)
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("SeaExport.Remove")))]
                          ),
                          _c(
                            "el-button",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.step === 2 && scope.row.analysisId,
                                  expression:
                                    "step === 2 && scope.row.analysisId"
                                }
                              ],
                              staticStyle: { color: "red" },
                              attrs: { type: "text" },
                              on: {
                                click: function($event) {
                                  return _vm.deleteFile(scope.row)
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("SeaExport.Delete")))]
                          ),
                          _c(
                            "el-button",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.step === 2 && scope.row.analysisId,
                                  expression:
                                    "step === 2 && scope.row.analysisId"
                                }
                              ],
                              attrs: { type: "text" }
                            },
                            [_vm._v(_vm._s(_vm.$t("SeaExport.Parsing")))]
                          ),
                          _c(
                            "el-button",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value:
                                    scope.row.analysisId &&
                                    scope.row.analysisState === 1,
                                  expression:
                                    "scope.row.analysisId && scope.row.analysisState === 1"
                                }
                              ],
                              attrs: { type: "text" }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("SeaExport.ParsingComplete"))
                              )
                            ]
                          )
                        ]
                      }
                    }
                  ])
                })
              ],
              1
            )
          ],
          1
        ),
        _c("div", { staticClass: "ai-recognition-warn" }, [
          _c("img", {
            attrs: {
              src: require("@/assets/icons/ai-recognition-bell.png"),
              alt: ""
            }
          }),
          _c("p", [_vm._v(_vm._s(_vm.$t("SeaExport.AiRecognitionWarn")))])
        ])
      ]),
      _c(
        "span",
        {
          staticClass: "button-dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c(
            "el-button",
            {
              staticStyle: {
                width: "110px",
                height: "40px",
                "margin-right": "19px"
              },
              attrs: { size: "medium", plain: true },
              on: {
                click: function($event) {
                  _vm.innerVisible = false
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("SeaExport.Cancel")))]
          ),
          _c(
            "el-button",
            {
              staticStyle: { width: "110px", height: "40px" },
              attrs: {
                size: "medium",
                type: "primary",
                disabled: _vm.step !== 1
              },
              on: { click: _vm.startRecognitionHandler }
            },
            [_vm._v(_vm._s(_vm.$t("SeaExport.StartRecognition")))]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }